import React, { useRef, useState } from "react";
import {
  TableCustom,
  Loading,
  SectionHeading,
  WrapperAdvancedSearch,
} from "../../components/common";
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { useEntidad } from "../../components/hooks/useEntidad";
import { getDateNow } from "../../utils/convert";
import { ServerRequest } from "../../utils/apiweb";
import { APIS } from "../../config/apis";
import { isNull } from "../../utils/validator";
import { useAccess } from "../../components/hooks/useAccess";
import ModeloDeclaracionJuradaEmisionDefinicionGrid from "../../components/controls/ModeloDeclaracionJuradaEmisionDefinicionGrid";

function ModelosDeclaracionesJuradasView() {
  const [state, setState] = useState({
    loading: false,
    listEmisionDefinicion: [],
    listModeloDeclaracionJurada: [],
    listModeloDeclaracionJuradaEmisionDefinicion: [],
  });

  const searchRef = useRef();

  const [getListEntidad] = useEntidad({
    entidades: ["ModeloDeclaracionJurada","EmisionDefinicion"],
    onLoaded: (entidades, isSuccess, error) => {
      if (isSuccess) {
        SearchModeloDeclaracionesJuradasEmisionDefiniciones();
        const listEmisionDefinicion = getListEntidad("EmisionDefinicion");
        const listModeloDeclaracionJurada = getListEntidad("ModeloDeclaracionJurada");
        setState((prev) => ({ ...prev,
          listEmisionDefinicion: listEmisionDefinicion,
          listModeloDeclaracionJurada: listModeloDeclaracionJurada
        }));
      } else {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: null,
  });

  const [hasEditAccess, setHasEditAccess] = useState(false);
  useAccess({
    key: "ModelosDeclaracionesJuradasView",
    onLoaded: (data, isSuccess, error) => {
      if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      else setHasEditAccess(data.some((x) => x.codigo === "modelo-declaracion-jurada_edit"));
    },
  });

  const getModeloDeclaracionJuradaValor = (id) => {
    const today = getDateNow();
    let currentValue = "";
    if (state.listModeloDeclaracionJuradaEmisionDefinicion.length > 0) {
      const listModeloDeclaracionJuradaEmisionDefinicionXModeloDeclaracionJurada = state.listModeloDeclaracionJuradaEmisionDefinicion.filter(
          (f) => f.idModeloDeclaracionJurada === id
      );
      const currentRow = listModeloDeclaracionJuradaEmisionDefinicionXModeloDeclaracionJurada.find(
          (x) =>
              (x.fechaDesde <= today || isNull(x.fechaDesde)) &&
              (x.fechaHasta >= today || isNull(x.fechaHasta))
      );
      if (!isNull(currentRow)) {
        const emisionDefinicion = state.listEmisionDefinicion.find((f) => f.id === currentRow.idEmisionDefinicion);
        if (emisionDefinicion) {
          currentValue = `${emisionDefinicion.descripcion} (${emisionDefinicion.periodo})`;
        }
      }
    }
    return currentValue;
  };

  const cellE = ({ row }) => (
      <div
          className="action"
          {...row.getToggleRowExpandedProps({ title: "ver historial de cambios" })}
      >
        <div className="link">
          {row.isExpanded ? (
              <span className="material-symbols-outlined icon-expanded">
            expand_more
          </span>
          ) : (
              <span className="material-symbols-outlined">chevron_right</span>
          )}
        </div>
      </div>
  );

  const tableColumns = [
    {
      Header: "", Cell: cellE, id: "expander", width: "3%", disableGlobalFilter: true, disableSortBy: true,
    },
    { Header: "Código", accessor: "codigo", width: "10%" },
    { Header: "Modelo de declaración jurada", accessor: "nombre", width: "40%" },
    {
      Header: "Definición de emisión actual",
      Cell: (props) => getModeloDeclaracionJuradaValor(props.row.original.id), id: "valorActual", accessor: "id", width: "40%",
    },
    {
      Header: "Activo",
      Cell: (props) => (props.row.original.activo ? "Sí" : "No"), id: "activo", accessor: "id", width: "7%",
    }
  ];

  const subComponent = ({ row }) => (
      <div className="form-sub-component">
        <div className="row">
          <div className="col-12 col-lg-8 p-top-15">
            <label className="form-label">Historial de cambios</label>
            <ModeloDeclaracionJuradaEmisionDefinicionGrid
                disabled={!row.original.activo || !hasEditAccess}
                data={{
                  idModeloDeclaracionJurada: row.original.id,
                  list: state.listModeloDeclaracionJuradaEmisionDefinicion
                             .filter((f) => f.idModeloDeclaracionJurada === row.original.id)
                }}
                onChange={(row) => {
                  ActionModeloDeclaracionJuradaEmisionDefinicion(row);
                }}
            />
          </div>
        </div>
      </div>
  );

  function SetModeloDeclaracionesJuradas(filterFunc = null) {
    const data = getListEntidad("ModeloDeclaracionJurada");
    let list = filterFunc ? filterFunc(data) : data;
    setState((prev) => ({...prev,
      listModeloDeclaracionJurada: list,
    }));
  }

  function SearchModeloDeclaracionesJuradasEmisionDefiniciones() {
    setState((prev) => ({ ...prev, loading: true, listModeloDeclaracionJuradaEmisionDefinicion: [] }));

    const callbackSuccess = (response) => {
      response
          .json()
          .then((data) => {
            data.forEach((x) => {
              if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
              if (x.fechaHasta) x.fechaHasta = new Date(x.fechaHasta);
            });
            setState((prev) => ({...prev,
              loading: false,
              listModeloDeclaracionJuradaEmisionDefinicion: data,
            }));
          })
          .catch((error) => {
            ShowToastMessage(
                ALERT_TYPE.ALERT_ERROR,
                "Error procesando respuesta: " + error
            );
            setState((prevState) => ({ ...prevState, loading: false }));
          });
    };

    const paramsUrl = `/emision-definicion`;

    ServerRequest(
        REQUEST_METHOD.GET,
        null,
        true,
        APIS.URLS.MODELO_DECLARACION_JURADA,
        paramsUrl,
        null,
        callbackSuccess,
        (res) => {
          res.json().then((error) => {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error.message);
            setState((prevState) => ({ ...prevState, loading: false }));
          });
        },
        (error) => {
          ShowToastMessage(
              ALERT_TYPE.ALERT_ERROR,
              "Error procesando solicitud: " + error.message
          );
          setState((prevState) => ({ ...prevState, loading: false }));
        }
    );
  }

  function ActionModeloDeclaracionJuradaEmisionDefinicion(row) {
    const action = row.state;
    delete row.state;
    switch (action) {
      case "a":
        BindModeloDeclaracionJuradaEmisionDefinicion(row);
        break;
      case "r":
        UnbindModeloDeclaracionJuradaEmisionDefinicion(row);
        break;
      default:
        break;
    }
  }

  function BindModeloDeclaracionJuradaEmisionDefinicion(row) {
    const paramsUrl = `/${row.idModeloDeclaracionJurada}/emision-definicion/bind`;
    SaveModeloDeclaracionJuradaEmisionDefinicion(paramsUrl, row);
  }

  function UnbindModeloDeclaracionJuradaEmisionDefinicion(row) {
    const paramsUrl = `/${row.idModeloDeclaracionJurada}/emision-definicion/unbind`;
    SaveModeloDeclaracionJuradaEmisionDefinicion(paramsUrl, row);
  }

  function SaveModeloDeclaracionJuradaEmisionDefinicion(paramsUrl, dataBody) {
    setState((prev) => ({ ...prev, loading: true }));

    const callbackSuccess = (response) => {
      response
          .json()
          .then(() => {
            SearchModeloDeclaracionesJuradasEmisionDefiniciones();
            setState((prev) => ({ ...prev, loading: false }));
          })
          .catch((error) => {
            ShowToastMessage(
                ALERT_TYPE.ALERT_ERROR,
                "Error procesando respuesta: " + error
            );
            setState((prev) => ({ ...prev, loading: false }));
          });
    };

    ServerRequest(
        REQUEST_METHOD.PUT,
        null,
        true,
        APIS.URLS.MODELO_DECLARACION_JURADA,
        paramsUrl,
        dataBody,
        callbackSuccess,
        (res) => {
          res.json().then((error) => {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error.message);
            setState((prev) => ({ ...prev, loading: false }));
          });
        },
        (error) => {
          ShowToastMessage(
              ALERT_TYPE.ALERT_ERROR,
              "Error procesando solicitud: " + error.message
          );
          setState((prev) => ({ ...prev, loading: false }));
        }
    );
  }

  function onSearch() {
    SetModeloDeclaracionesJuradas(FilterModeloDeclaracionesJuradas);
  }

  function FilterModeloDeclaracionesJuradas(data) {
    const { nombre, activo } = searchRef.current?.filters || {};

    let newList = [...data];

    if (nombre && nombre.length > 0) {
      newList = newList.filter(
          (f) => f.nombre.toLowerCase().indexOf(nombre.toLowerCase()) >= 0
      );
    }

    if (activo) {
      newList = newList.filter((f) => f.activo);
    }

    return newList;
  }

  return (
      <>
        <Loading visible={state.loading} />

        <SectionHeading
            titles={[{ title: "Configuración" }, { title: "Modelos de declaraciones juradas" }]}
        />

        <section className="section-accordion">
          <WrapperAdvancedSearch
              ref={searchRef}
              filters={[
                {
                  title: "Nombre",
                  field: "nombre",
                  type: "string",
                  size: 6,
                  searchOnEnter: true,
                },
                {
                  title: "Estado",
                  field: "activo",
                  type: "selectLista",
                  size: 3,
                  options: [
                    { value: null, label: "Todos" },
                    { value: true, label: "Activos" },
                  ],
                },
              ]}
              onSearch={onSearch}
          />

          <div className="m-top-20">
              <TableCustom
                  showFilterGlobal={false}
                  className="TableCustomBase"
                  columns={tableColumns}
                  data={state.listModeloDeclaracionJurada}
                  subComponent={subComponent}
              />
          </div>
        </section>
      </>
  );
}

export default ModelosDeclaracionesJuradasView;
